<template>
  <div>
    <v-row v-for="(questao, idx) in questoes" :key="questao.id" class="mb-6">
      <v-col cols="12">
        <p
            :class="{
                'erro-pergunta': exibirErros && questao.obrigatoria && (questao.resposta === null || questao.resposta === '' || questao.resposta === undefined)
            }"
            >
          {{ questao.pergunta }}
          <span v-if="questao.obrigatoria">*</span>
        </p>

        <!-- Tipo escala 1 a 5 -->
        <v-btn-toggle
          v-if="questao.tipo === tipoPergunta.NOTA1A5"
          v-model="questao.resposta"
          class="mt-2"
          dense
          :class="{ 'no-pointer': disabled }"
          @change="!disabled && emitUpdate(idx, questao.resposta)"
        >
          <v-btn
            v-for="item in 5"
            :key="item"
            :value="item"
            :color="Number(questao.resposta) === item ? 'primary' : ''"
          >
            {{ item }}
          </v-btn>
        </v-btn-toggle>

        <!-- Tipo texto -->
        <v-textarea
          solo
          hide-details
          v-else-if="questao.tipo === tipoPergunta.ABERTA"
          v-model="questao.resposta"
          rows="2"
          outlined
          maxlength="500"
          :disabled="disabled"
          :error="exibirErros && questao.obrigatoria && (questao.resposta === null || questao.resposta === '')"
          @input="emitUpdate(idx, questao.resposta)"
        />

        <div
          v-if="exibirErros && questao.obrigatoria && (questao.resposta === null || questao.resposta === '' || questao.resposta === undefined)"
          class="campo-obrigatorio"
        >
          Campo Obrigatório
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import tipoPergunta from '~/commons/enums/tipo-pergunta.enum';

export default {
  name: "QuestionarioDinamicoFormacao",
  data: () => ({
    tipoPergunta,
  }),
  props: {
    questoes: {
        type: Array,
        required: true,
    },
    exibirErros: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
  },
  methods: {
    emitUpdate(idx, resposta) {
      this.$emit("update", { idx, resposta });
    },
  },
};
</script>

<style scoped>

.erro-pergunta {
  color: #d32f2f;
}

.campo-obrigatorio {
  color: #d32f2f;
  font-size: 0.9em;
  margin-top: 4px;
}

.v-btn-toggle {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}

.v-btn-toggle .v-btn {
  border-radius: 50% !important;
  height: 35px;
  min-width: 35px!important;
  padding: 0;
  text-align: center;
}

.v-btn-toggle .v-btn.v-btn--active {
  border-color: #1976d2;
  background-color: #1976d2;
  color: white;
}

.no-pointer {
  pointer-events: none !important;
  user-select: none !important;
  opacity: 1;
}
</style>